/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureRequestStatus } from './SignatureRequestStatus';
import {
    SignatureRequestStatusFromJSON,
    SignatureRequestStatusFromJSONTyped,
    SignatureRequestStatusToJSON,
    SignatureRequestStatusToJSONTyped,
} from './SignatureRequestStatus';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface SignatureRequestDto
 */
export interface SignatureRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignatureRequestDto
     */
    id: string;
    /**
     * 
     * @type {UserDto}
     * @memberof SignatureRequestDto
     */
    signer: UserDto;
    /**
     * 
     * @type {SignatureRequestStatus}
     * @memberof SignatureRequestDto
     */
    status: SignatureRequestStatus;
    /**
     * 
     * @type {Date}
     * @memberof SignatureRequestDto
     */
    signedAt?: Date;
    /**
     * Grid position for the visual signature card in the PDF
     * @type {number}
     * @memberof SignatureRequestDto
     */
    signerIndex: number;
}



/**
 * Check if a given object implements the SignatureRequestDto interface.
 */
export function instanceOfSignatureRequestDto(value: object): value is SignatureRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('signer' in value) || value['signer'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('signerIndex' in value) || value['signerIndex'] === undefined) return false;
    return true;
}

export function SignatureRequestDtoFromJSON(json: any): SignatureRequestDto {
    return SignatureRequestDtoFromJSONTyped(json, false);
}

export function SignatureRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'signer': UserDtoFromJSON(json['signer']),
        'status': SignatureRequestStatusFromJSON(json['status']),
        'signedAt': json['signedAt'] == null ? undefined : (new Date(json['signedAt'])),
        'signerIndex': json['signerIndex'],
    };
}

export function SignatureRequestDtoToJSON(json: any): SignatureRequestDto {
    return SignatureRequestDtoToJSONTyped(json, false);
}

export function SignatureRequestDtoToJSONTyped(value?: SignatureRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'signer': UserDtoToJSON(value['signer']),
        'status': SignatureRequestStatusToJSON(value['status']),
        'signedAt': value['signedAt'] == null ? undefined : ((value['signedAt']).toISOString()),
        'signerIndex': value['signerIndex'],
    };
}

